"use client";

import { useRouter } from "next/navigation";
import { FC, useEffect } from "react";

import { Footer, MediaQuery } from "@/shared/components";
import { Button } from "@/shared/ui";
import { useUserStore } from "stores/user.store";

import { RoleButton } from "../role-button";

import styles from "./choose-role.module.scss";

const ChooseRoleForm: FC = () => {
  const { push } = useRouter();

  const role = useUserStore((state) => state.role);
  const setRole = useUserStore((state) => state.actions.setRole);

  useEffect(() => {
    setRole("muse");
  }, []);

  return (
    <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
      <div className={styles.rolesContainer}>
        <RoleButton title="Woman" selected={role === "muse"} onClick={() => setRole("muse")} />
        <RoleButton title="Man" selected={role === "alpha"} onClick={() => setRole("alpha")} />
      </div>

      <Button size="big" onClick={() => push("/auth/signup")}>
        Continue
      </Button>

      <MediaQuery.Laptop>
        <Footer fixedAtBottom />
      </MediaQuery.Laptop>
    </form>
  );
};

export { ChooseRoleForm };
